import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=b8bbabb8&scoped=true"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"
import style0 from "./signature.vue?vue&type=style&index=0&id=b8bbabb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bbabb8",
  null
  
)

export default component.exports